import { Component, OnInit } from '@angular/core';
import { GlobalVarService } from 'src/app/core/services/shared/global-var.service';

@Component({
  selector: 'app-header1',
  templateUrl: './header1.component.html',
  styleUrls: ['./header1.component.scss']
})
export class Header1Component implements OnInit {
  basepath = "";
  imageURL="";
  constructor(

    public globalvar: GlobalVarService,
  ) {

    this.basepath = this.globalvar.basepath;
   }

  ngOnInit(): void {

    this.globalvar.organizationLoaded.subscribe((resp) => {
      if (resp) {
        this.basepath = this.globalvar.basepath;
        this.imageURL = this.globalvar.logoUrl;
       
      }
    });
  }

}
